import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import filterChipUtil from '@/utilities/filterChipUtil';

import { srpDuckPreset } from '@/ducks/presets/index.js';

import srpFiltersDuck from './srpFiltersDuck';

const DEFAULT_EMPTY_ARRAY = [];
const DEFAULT_EMPTY_STRING = '';
const DEFAULT_EMPTY_OBJECT = {};

const getFilterLabel = ({ filterKey, filterLabel, filterValue }) => {
    let label = '';
    switch (filterKey) {
        case 'startYear':
        case 'endYear':
            label = filterChipUtil.getYearLabel({ [filterKey]: [filterValue] });
            break;
        case 'minPrice':
        case 'maxPrice':
            label = filterChipUtil.getPriceLabel({ [filterKey]: [filterValue] });
            break;
        default:
            label = filterChipUtil.formatChipLabel(filterLabel, filterKey);
            break;
    }
    return label;
};

const formatStrongAttributeFilter = (filter, filtersOptions) => {
    const strongFilterKey = filter.filterKey;
    const strongFilterValue = filter.filterValue;

    const strongFilterOption = filtersOptions?.[strongFilterKey];
    const strongFilterLabel = strongFilterOption?.options?.find(({ value }) => value === strongFilterValue)?.label;

    const label = getFilterLabel({
        filterKey: strongFilterKey,
        filterLabel: strongFilterLabel,
        filterValue: strongFilterValue,
    });

    // if strong attribute filter was available and had a valid label then
    // format the strong attribute filter to have same structure as a suggested filter
    return (strongFilterKey && label) ? ({
        codes: {
            [strongFilterKey]: strongFilterValue ? [strongFilterValue] : DEFAULT_EMPTY_ARRAY,
        },
        name: label || DEFAULT_EMPTY_STRING,
    }) : DEFAULT_EMPTY_OBJECT;
};

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'strongAttributes',
    initialState: {
        filters: [],
    },
}).extend({
    selectors: (duck) => ({
        getStrongAttributesFilters: new DuckSelector((selectors) => createSelector(
            selectors.getDuckState,
            (localState) => localState.filters,
        )),
        getFirstStrongAttributesFilter: new DuckSelector((selectors) => createSelector(
            selectors.getStrongAttributesFilters,
            srpFiltersDuck.selectors.getFiltersOptions,
            srpFiltersDuck.selectors.getFiltersValues,
            (strongFiltersValues, filtersOptions, filtersValues) => {
                // Get the first strong attribute filter that is not already a selected filter
                const selectedFilters = Object.keys(filtersValues);
                const availableStrongFilters = strongFiltersValues?.filter((filter) => !selectedFilters.includes(filter.filterKey));

                const firstFilter = availableStrongFilters?.[0];
                return firstFilter ? formatStrongAttributeFilter(firstFilter, filtersOptions) : DEFAULT_EMPTY_OBJECT;
            }
        )),
        getFormattedStrongAttributesFilters: new DuckSelector((selectors) => createSelector(
            selectors.getStrongAttributesFilters,
            srpFiltersDuck.selectors.getFiltersOptions,
            (strongFiltersValues, filtersOptions) => {
                // Format all strong attribute filters
                const formattedFilters = strongFiltersValues?.map((filter) => formatStrongAttributeFilter(filter, filtersOptions))
                    .filter((filter) => filter && Object.keys(filter).length > 0);
                return formattedFilters || DEFAULT_EMPTY_ARRAY;
            }
        )),
    }),
});
